"use client";

import { useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { analytics } from "@/lib/analytics/core";
import { sanitizePagePathForAnalytics } from "@/lib/analytics/sanitizePagePathForAnalytics";

/**
 * Fires a `page_view` event on every client-side route change.
 * Mount once in the root layout.
 */
export function AnalyticsPageTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    const rawPath = searchParams.toString()
      ? `${pathname}?${searchParams.toString()}`
      : pathname;
    const fullPath = sanitizePagePathForAnalytics(rawPath);

    if (fullPath === prevPath.current) return;
    prevPath.current = fullPath;

    analytics.track("page_view", {
      page_path: fullPath,
      page_title: document.title,
      page_referrer: document.referrer,
    });
  }, [pathname, searchParams]);

  return null;
}
